import { createAction, props } from '@ngrx/store';

export const updateSerpApi = createAction(
  '[SerpApi] Update SerpApi',
  props<{ user_id: number; location: string; domain: string; language: string }>()
);

export const updateSerpApiSuccess = createAction(
  '[SerpApi] Update SerpApi Success',
  props<{ response: any }>()
);

export const updateSerpApiFailure = createAction(
  '[SerpApi] Update SerpApi Failure',
  props<{ error: any }>()
);

// Load Locations Actions
export const loadLocations = createAction(
  '[SerpApi] Load Locations',
  props<{ location: string }>()
);
export const loadLocationsSuccess = createAction(
  '[SerpApi] Load Locations Success',
  props<{ locations: any[] }>()
);
export const loadLocationsFailure = createAction(
  '[SerpApi] Load Locations Failure',
  props<{ error: any }>()
);

// Load Domains Actions
export const loadDomains = createAction('[SerpApi] Load Domains');
export const loadDomainsSuccess = createAction(
  '[SerpApi] Load Domains Success',
  props<{ domains: any[] }>()
);
export const loadDomainsFailure = createAction(
  '[SerpApi] Load Domains Failure',
  props<{ error: any }>()
);

// Load Languages Actions
// Load Languages Actions
export const loadLanguages = createAction('[SerpApi] Load Languages');
export const loadLanguagesSuccess = createAction(
  '[SerpApi] Load Languages Success',
  props<{ languages: any[] }>()
);
export const loadLanguagesFailure = createAction(
  '[SerpApi] Load Languages Failure',
  props<{ error: any }>()
);
